// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__1Wnjc","error":"InputSecondary_error__3q8Ml","disabled":"InputSecondary_disabled__26mmB"};